import React, { useMemo } from "react";
import { debounce } from "lodash";
import { Icon } from "assets/icons";

import styles from "./styles.module.scss";

const DEBOUNCE_MS = 400;

/**
 * Поиск с debounce. Управляемый (value + onChange)
 * или дебаунснутый (onSearch).
 */
export const SearchInput = ({
  value,
  onChange,
  onSearch,
  placeholder = "Поиск",
  className,
}) => {
  const debouncedSearch = useMemo(
    () => (onSearch ? debounce(onSearch, DEBOUNCE_MS) : null),
    [onSearch]
  );

  const handleChange = (ev) => {
    onChange?.(ev.target.value);
    debouncedSearch?.(ev.target.value);
  };

  return (
    <div className={`${styles.searchInput} ${className || ""}`}>
      <span className={styles.searchIcon}>
        <Icon type="search" size={16} />
      </span>
      <input
        className={styles.input}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </div>
  );
};
